import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { buildQuery } from "../../../utils/buildQuery";

export const ShelfAvailabilityApi = createApi({
  reducerPath: "ShelfAvailabilityReport",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_BACKEND2_URL}/v1`,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("token");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      headers.set("Accept", "application/json");
      return headers;
    },
    credentials: "include",
  }),
  endpoints: (builder) => ({
    getShelfAvailabilityReport: builder.query({
      query: (params) => {
        const query = buildQuery(params);
        return `/shelf-availability${query}`;
      },
    }),
    getShelfAvailabilityStores: builder.query({
      query: ({ formId }) => `/shelf-availability/filters/stores?formId=${formId}`,
    }),
    getShelfAvailabilityReps: builder.query({
      query: ({ formId }) => `/shelf-availability/filters/reps?formId=${formId}`,
    }),
    getShelfAvailabilityProducts: builder.query({
      query: ({ formId }) => `/shelf-availability/filters/products?formId=${formId}`,
    }),
    /** GET binary export (e.g. xlsx) — same path as MaintBackend shelf-availability/export */
    getShelfAvailabilityExport: builder.query({
      async queryFn({ formId, ...rest } = {}, _queryApi, _extraOptions) {
        const fid =
          formId ??
          process.env.REACT_APP_SHELF_FORM_ID;
        if (!fid) {
          return {
            error: {
              status: "CUSTOM_ERROR",
              data: "Missing formId for shelf availability export",
            },
          };
        }
        // Forward the same filters as the on-screen report so the Excel matches it
        // (date range, store/rep/sku/states, store types and categories).
        const query = buildQuery({ formId: fid, ...rest });
        try {
          const result = await fetch(
            `${process.env.REACT_APP_BACKEND2_URL}/v1/shelf-availability/export${query}`,
            {
              method: "GET",
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
                Accept: "*/*",
              },
            },
          );
          if (!result.ok) {
            return {
              error: { status: result.status, data: await result.text() },
            };
          }
          const blob = await result.blob();
          return { data: blob };
        } catch (err) {
          return { error: { status: "FETCH_ERROR", data: err.message } };
        }
      },
    }),
  }),
});

export const {
  useLazyGetShelfAvailabilityReportQuery,
  useLazyGetShelfAvailabilityStoresQuery,
  useLazyGetShelfAvailabilityRepsQuery,
  useLazyGetShelfAvailabilityProductsQuery,
  useLazyGetShelfAvailabilityExportQuery,
} = ShelfAvailabilityApi;
